// extracted by mini-css-extract-plugin
export var documentation = "_iq-1";
export var menu = "_iq-0";